import React from 'react';

export function OxygenMask() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        d="M 2.59375 0 L 2.59375 2.59375 L 9.5 2.59375 L 2 11.59375 L 2 14 L 13.8125 14 L 13.8125 11.40625 L 6.09375 11.40625 L 13.59375 2.40625 L 13.59375 0 Z M 16.5 8 L 16.5 9.8125 L 21.40625 9.8125 L 16 16.3125 L 16 18 L 24.5 18 L 24.5 16.09375 L 19 16.09375 L 24.40625 9.6875 L 24.40625 8 Z M 6.40625 17 L 6.40625 18.6875 L 10.8125 18.6875 L 6 24.40625 L 6 26 L 13.6875 26 L 13.6875 24.40625 L 8.6875 24.40625 L 13.5 18.59375 L 13.5 17 Z"
        fill="#D0D3DC"
      />
    </svg>
  );
}
